/**
 * P1-09: Toolbar 骨架（容器 + 横向布局）。
 *
 * 对齐旧 WToolbar（js/jsx/toolbar.jsx.js:733-768）：
 * - `.icons-container` flex 横排（样式由旧 default.css:1955-1958 提供）；
 * - 图标顺序：FPS → Pollution → Happiness → Energy → BLS → (MOTD 停用) → Login；
 * - 各指示器以 useGameTick 精确选择器订阅，取代旧版整树每 tick setState
 *   （toolbar.jsx.js:738-743）。
 */
import { TooltipProvider } from "../../components/Tooltip/TooltipProvider";
import { useGameTick } from "../../bridge/useGameTick";
import {
  ToolbarBls,
  ToolbarEnergy,
  ToolbarFps,
  ToolbarHappiness,
  ToolbarPollution,
} from "./indicators";
import { ToolbarLogin } from "./Login";

/**
 * 面板入口：自带 TooltipProvider（toolbar 是 tooltip 的主要消费方），
 * 由 TopBar 直接组合到同一个 React root。
 */
export default function ToolbarPanel() {
  return (
    <TooltipProvider>
      <Toolbar />
    </TooltipProvider>
  );
}

function Toolbar() {
  const disablePollution = useGameTick((game) => game?.opts.disablePollution ?? true);

  return (
    <div className="icons-container">
      <ToolbarFps />
      {/* 图标顺序与旧 WToolbar.getIcons 一致（toolbar.jsx.js:749-761） */}
      {!disablePollution && <ToolbarPollution />}
      <ToolbarHappiness />
      <ToolbarEnergy />
      <ToolbarBls />
      {/* MOTD：与旧版一致保持不挂载（toolbar.jsx.js:757），组件保留在 indicators.tsx */}
      <ToolbarLogin />
    </div>
  );
}
